import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: {},
    token:''
  },
  mutations: {
    increment(state) {
      // 变更状态
      state.user = '',
      state.token = ''
    }
  },
  actions: {
    LogOut(context) {
      context.commit('increment')
    }
  },
  modules: {

  }
})
